import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChatHttpService, ChatRoom } from './chat-http.service';
import { ResponseCallStart, WebsocketService } from './websocket.service';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class ChatService {
  chatAll$ = new BehaviorSubject<ChatRoom[]>([]);
  // @ts-ignore
  chatCurrent$ = new BehaviorSubject<ChatRoom>(null);
  callActive$ = new BehaviorSubject<boolean>(false);
  chatLoaded$ = new BehaviorSubject<boolean>(false);

  idUserChatCall: number | null = null;
  initDestroyJitsy = false;
  constructor(private chatHttp: ChatHttpService,
              private websocketService: WebsocketService,
              private authService: AuthService) {
  }

  initChats() {
    this.chatHttp.getChats(null).subscribe(chats => {
      this.chatAll$.next(chats);
      this.updateCurrentChatOnAll();
      this.chatLoaded$.next(true);
    }, error => {
      console.error(error);
    });
  }

  chatActive(room: ChatRoom) {
    this.chatCurrent$.next(room);
  }

  sendMessage(text: string) {
    return this.chatHttp.chatMessageAdd({
      ChatID: this.chatCurrent$.getValue().ChatID,
      MsgText: text,
    })
  }
  chatEndWebsocket(message: any) {
    return this.websocketService.sendMessage(message);
  }

  chatCloseMessage() {
    this.websocketService.sendMessage({
      Event: "call_end",
      RecipientID: this.idUserChatCall,
      RecipientType: 'user'});
    // this.idUserChatCall = null;
    this.callActive$.next(false);
  }

/*
  hungUpMessage() {
    this.websocketService.sendMessage({
      Event: "message",
      typeEvent: 'hangUp',
      RecipientID: this.idUserChatCall,
      RecipientType: 'user'});
    // this.idUserChatCall = null;
    this.callActive$.next(false);
  }
*/

  chatUpdate(chatId?: number) {
    this.chatHttp.getChats(null).subscribe(chats => {
      this.chatAll$.next(chats);
      this.updateCurrentChatOnAll();
    }, error => {
      console.error(error);
    });
  }

  private updateCurrentChatOnAll() {
    const currentChatId = this.chatCurrent$.getValue()?.ChatID;
    if (currentChatId) {
      this.chatCurrent$.next(this.chatAll$.getValue().filter(room => room.ChatID === currentChatId)[0] || null)
    }
  }


  callEnd() {
    this.callActive$.next(false);
  }

  callStart(data: ResponseCallStart) {
    this.idUserChatCall = data.UserID;
    this.websocketService.callStart(data)
    this.callActive$.next(true)
  }

}
